Queue = require 'promise-queue'
Queue.configure require('bluebird')



// WEBPACK FOOTER //
// ./app/scripts/init/configure-promise-queue.coffee